import React from 'react'
import InnerBanner from '../../../Components/InnerBanner/InnerBanner'
import { Container, Row, Col, Accordion } from 'react-bootstrap'
import { useQuery } from '@tanstack/react-query'
import SkeletonLoader from '../../../Components/SkeletonLoader/SkeletonLoader'
import { getFaqs } from '../../../Services/User/Faqs'
import './Faqs.css'

const Faqs = () => {
    const { data: faqs, isLoading: isLoadingFaqs } = useQuery({
        queryKey: ['faqs'],
        queryFn: () => getFaqs()
    })
    const reversedFaqs = [...(faqs?.data || [])]?.reverse();
    return (
        <>
            <InnerBanner heading="FAQs" />
            <section className="py-sm-5 py-4">
                <Container>
                    <Row>
                        <Col xs={12}>
                            {isLoadingFaqs ? <><SkeletonLoader /></> : (
                                <div>
                                    <Accordion className='faq-accordion' defaultActiveKey="0">
                                        {reversedFaqs?.map((faq, index) => (
                                            <Accordion.Item eventKey={index} key={index}>
                                                <Accordion.Header>Q: {faq.question}</Accordion.Header>
                                                <Accordion.Body className='mt-3'>
                                                    {faq.text && <p className='mb-0'>Ans: {faq.text}</p>}
                                                    {(faq.image || faq.video) && (
                                                        <Row>
                                                            <Col xs={6}>
                                                                {faq.image && <img src={faq?.image?.path} alt={faq.question} className='mt-3' />}
                                                            </Col>
                                                            <Col xs={6}>
                                                                {faq.video && <video src={faq?.video?.path} alt={faq.question} controls className='mt-3' />}
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Faqs